// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { de } from "./ArenaDialog.jsx";
import { IconCards } from "../../components/icons.jsx";
import { IconPlayerPlay } from "../../components/icons.jsx";
export const rm = u => u ? `/${u.replace(/^\/+/, "")}` : void 0;
export const ma = u => u.toLocaleString("ru-RU");
export const Ji = u => u.toLowerCase().replace(/[^a-z]/g, "");
export function ArenaMedia({
  card: u,
  playback: o = !1,
  onAspectRatio = undefined
}) {
  const [m, r] = React.useState(),
    g = rm(u.thumbnailPath),
    j = rm(u.mediaPath),
    B = o && u.mediaType === "video" && j;
  return jsxRuntime.jsxs("span", {
    className: `${de.media} ${o ? de.largeMedia : ""}`,
    children: [B && m !== j ? jsxRuntime.jsx("video", {
      src: j,
      poster: g,
      controls: !0,
      playsInline: !0,
      muted: !0,
      preload: "metadata",
      "aria-label": u.name,
      onError: () => r(j)
    }, j) : g && m !== g ? jsxRuntime.jsx("img", {
      src: g,
      alt: u.name,
      loading: "lazy",
      decoding: "async",
      onLoad: event => {
        const { naturalWidth, naturalHeight } = event.currentTarget;
        if (naturalWidth > 0 && naturalHeight > 0) onAspectRatio?.(naturalWidth / naturalHeight);
      },
      onError: () => r(g)
    }) : jsxRuntime.jsxs("span", {
      className: de.mediaFallback,
      children: [jsxRuntime.jsx(IconCards, {}), jsxRuntime.jsx("small", {
        children: "Нет превью"
      })]
    }), !o && u.mediaType === "video" && jsxRuntime.jsx("span", {
      className: de.videoBadge,
      title: "Видеокарта",
      children: jsxRuntime.jsx(IconPlayerPlay, {
        "aria-label": "Видео"
      })
    })]
  });
}
